export class WeekViewProjectModeUsersDetailsModel {
    constructor() {
        this.employeeName = "";
        this.projectsTotalTime = [];
    }
}
export default class WeekViewProjectModeUsersDetails extends WeekViewProjectModeUsersDetailsModel {
    constructor(model) {
        super();
        Object.assign(this, model);
    }
}
